import styles from "@components/__templates__/Content2019Page/Content2019Page.module.scss";
import Grid from "@components/Grid/Grid";
import RenderComponents from "@utilities/renderComponents";
import { TypeContent2019PageFields } from "types/contentful/TypeContent2019Page";
import Components from "../../__Components__/Components";

export const Content2019Page = (props: {
  content: TypeContent2019PageFields;
}) => {
  const { content } = props;
  const { bodyContent, headerBanner } = content;

  return (
    <Grid row customClass={content?.lbsThinkBlue ? styles.lbsThinkColor : ""}>
      <Grid column sm={12}>
        {headerBanner &&
          Components(
            {
              component: headerBanner.component,
              uid: headerBanner.uid,
              ...headerBanner.fields,
            },
            headerBanner.fields
          )}

        {RenderComponents(bodyContent)}
      </Grid>
    </Grid>
  );
};

export default Content2019Page;
